import React, { useState, useEffect } from "react";
import { Flex, Button, Image, Box, Text} from "@chakra-ui/react";
import { useLocation, Link } from "react-router-dom"; // Import useLocation and Link
import { StyleSheet, css } from 'aphrodite';

function Navbar () {
    const location = useLocation(); // Get the current location
    const [activeLink, setActiveLink] = useState("/"); // Default to the home page

    

    useEffect(() => {
        // Update the activeLink based on the current location
        setActiveLink(location.pathname);
    }, [location.pathname]);
    return (
    <>
    <Flex className={css(styles.navContainer)} justify="space-between" align="center">
        {/* Left Logo */}
        <Box className={css(styles.logoContainer)}>
            <Image 
                src="uottawa engineering.jpg" 
                alt="uOttawa Engineering" 
                className={css(styles.logo)}
            />
        </Box>

        {/* Navigation Links */}
        <Flex className={css(styles.navLinks)} justify="center" align="center">
            <Link to='/' className={css(styles.link)}>
                <Button 
                    variant='link'
                    className={css(styles.button, activeLink === "/" && styles.activeButton)}
                >
                    Home
                </Button>
            </Link>
            <Link to='/publications' className={css(styles.link)}>
                <Button 
                    variant='link'
                    className={css(styles.button, activeLink === "/publications" && styles.activeButton)}
                >
                    Publications
                </Button>
            </Link>
            <Link to='/awards' className={css(styles.link)}>
                <Button 
                    variant='link'
                    className={css(styles.button, activeLink === "/awards" && styles.activeButton)}
                >
                    Awards
                </Button>
            </Link>
            <Link to='/research-grants' className={css(styles.link)}>
                <Button 
                    variant='link'
                    className={css(styles.button, activeLink === "/research-grants" && styles.activeButton)}
                >
                    Grants & Projects
                </Button>
            </Link>
            <Link to='/service' className={css(styles.link)}>
                <Button 
                    variant='link'
                    className={css(styles.button, activeLink === "/service" && styles.activeButton)}
                >
                    Service
                </Button>
            </Link>
            <Link to='/teaching' className={css(styles.link)}>
                <Button 
                    variant='link'
                    className={css(styles.button, activeLink === "/teaching" && styles.activeButton)}
                >
                    Teaching
                </Button>
            </Link>
        </Flex>

        {/* Right Logo */}
        <Box className={css(styles.logoContainer)}>
            <Image 
                src="uottawa kanata.jpg" 
                alt="uOttawa Kanata North" 
                className={css(styles.logo)}
            />
        </Box>
    </Flex>
    <hr />
    <Flex justifyContent="center" position="relative" overflowX="auto" marginTop="70px">
      <Text fontSize="16.5" fontFamily="'Times New Roman'" fontWeight="normal" align="center">
        {" "}
      </Text>
    </Flex>
    </>
    );
}

const styles = StyleSheet.create({
    navContainer: {
        width: '100%',
        height: '80px', // Fixed height
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 20px',
        position: 'fixed',
        backgroundColor: '#d3d3d3',
        zIndex: 1000, // Ensures navbar is always on top
        top: 0, // Keep navbar at the top
        left: 0, // Ensure navbar is aligned left
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Optional shadow
    },
    navLinks: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1, // Makes sure it takes up available space
        gap: '3vw', // Space between buttons (responsive)
    },
    link: {
        textDecoration: 'none',
        flexShrink: 1, // Prevents excessive shrinking
        textAlign: 'center',
        minWidth: '100px', // Ensures minimum width
    },
    button: {
        color: '#315369',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        padding: '10px 15px',
        whiteSpace: 'nowrap',
        ":hover": {
            color: '#DC242C'
        }
    },
    activeButton: {
        color: '#DC242C',
    },
    logoContainer: {
        width: '180px', // Fixed size for consistency
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logo: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    }
});

export default Navbar;
